import * as Sentry from '@sentry/react';
import { timeOffSettingsDefault } from 'utils/constants/timeOffSettings';
import {
  isOrganizationTimeOffSettings,
  type IOrganizationTimeOffSettings,
} from 'utils/organization/timeOffSettings/timeOffSettingsTypes';

export const ERROR_TIMEOFF_SETTINGS_INVALID = 'InvalidTimeoffSettings';

export function parseOrganizationTimeOffSettings(
  settings: string,
  options?: {
    onInvalid?: 'throw' | 'returnDefault' | 'returnInvalid';
  }
): IOrganizationTimeOffSettings {
  const { onInvalid = 'throw' } = options ?? {};

  try {
    const result = JSON.parse(settings);

    if (isOrganizationTimeOffSettings(result)) {
      return result;
    } else {
      Sentry.captureMessage(ERROR_TIMEOFF_SETTINGS_INVALID, { extra: { json: settings, result } });

      if (onInvalid === 'throw') {
        throw new Error(ERROR_TIMEOFF_SETTINGS_INVALID, { cause: settings });
      } else if (onInvalid === 'returnDefault') {
        return timeOffSettingsDefault;
      } else if (onInvalid === 'returnInvalid') {
        return result;
      } else {
        throw new Error(`Unknown onInvalid option: ${onInvalid}`, { cause: settings });
      }
    }
  } catch (e: unknown) {
    Sentry.captureException(e, { extra: { settings } });
    throw e;
  }
}
